import React, { Component } from "react";
import AutoComponent from "../../common/AutoComponent";
import { fetchData } from "../../common/networkRequests";
import SubmitCustom from "../../FormComponents/SubmitCustom"
import EditCustom from "../../FormComponents/EditCustom"
import DeleteCustom from "../../FormComponents/DeleteCustom"
import { ClickableIcon } from "../../../components/oro-module/ajaxdata";
import { cloneDeep } from 'lodash';

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button
} from "reactstrap";
import classnames from "classnames";
import { shouldDisplayComponent, RelevantIcon, simple_csv_download, getCookie, setCookie, usUnicode } from "../../oro-module/commonFunctions";
import { FaFileExcel } from "react-icons/fa";
import "./styles.css";




export const createComponent = ({ allc = [], selectedFormTab = false, tabFastpath = false, wizard, grid, current, style = {}, schead, scfoot, theme = "", showtag = false, idx }) => {
  let { pageData, LocalVars } = current.props.parentState;
  let sv = LocalVars.subcomponentVisibility;


  let { currentPage } = current.props.parentState;
  if (selectedFormTab == 'general' && !tabFastpath) {
    tabFastpath = currentPage;
  }


  const toggleCollapseSubcomponents = (scn) => {
    let sv = LocalVars.subcomponentVisibility;
    if (sv[scn]) {
      sv[scn] = !sv[scn];
    } else {
      sv[scn] = true;
    }
    LocalVars.subcomponentVisibility = sv;
    current.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  }


  if (!style) { style = {}; }
  if (schead && !style['marginTop']) {
    // style['marginTop'] = 0;
  }
  let { session_date, user_code, user_description, assigned_roles, profile } = current.props.parentProps.parentState;
  let { username, roles, module, forms } = profile;
  let myroles = roles.map(r => r.role);
  let currenttitle;
  try {
    currenttitle = schead.props.children[1].props.children[0];
  }
  catch (e) { }
  let is_collapsed = false;

  if (sv[currenttitle]) {
    is_collapsed = true;
  }

  if (is_collapsed) {
    return (
      <div className={`${theme} sub-form-section col-sm-12`}>
        <div className="collapsed_subcomponent_title hand" onClick={() => toggleCollapseSubcomponents(currenttitle)} >
          {currenttitle} <RelevantIcon style={{ marginBottom: -3 }} icon="down-arrow-circle" />
        </div>
      </div>
    )
  } else {
    return (
      <div className={`${theme} sub-form-section col-sm-12`} style={style ? style : {}}>
        <div className={`row col-sm-12 scdiv`}>
          {schead}
          {allc.map((component, index) => {
            let isUnicodeTitle = "";
            let { forrole, formodule, title2name } = component;
            if (((component.tag && showtag) || !component.tag) && (!formodule || (formodule && formodule == module)) && (!forrole || (forrole && myroles.indexOf(forrole) != -1))) {
              if (component.subComponents) {
                let { shouldRender, conditionalRender } = shouldDisplayComponent({ current, pageData, component, allData: current.props.parentState });

                if (shouldRender == 1) {
                  let formc; let schead; let scfoot; let titl = false;
                  let { fields, pagination } = component['subComponents'];
                  let { style, theme } = component;
                  theme = theme ? theme : "defaulttheme";
                  if (fields) {
                    formc = fields;
                    schead = "";
                  } else {
                    formc = component['subComponents'];
                    titl = component.title ? component.title.split('icon-') : null;

                    isUnicodeTitle = usUnicode(component.title ? component.title : "");
                    isUnicodeTitle = isUnicodeTitle ? "large" : "";

                    let footerText = component.footer ? "* " + component.footer : "";
                    let x;
                    let padright = 2;
                    let iconaction;
                    // if (titl && titl[1]) {
                    //   padright += 18;
                    //   iconaction = component[titl[1]];
                    // }
                    // (titl && titl[1]) ? padright += 18 : x = 0;


                    if (component.titleStyle) {
                      let marginLeft = -18;
                      if (titl[0].length == 1) {
                        marginLeft = -13;
                      }
                      schead = titl ? <div className="sctitle-side col-sm-12" style={{ marginLeft }}> <span onClick={() => toggleCollapseSubcomponents(component.title)} className={`inside-title title hand ${theme} ${isUnicodeTitle}`} style={{ paddingRight: padright }}>{titl[0]}{titl[1] && <ClickableIcon action={iconaction} icon={titl[1]} current={current} />}</span>  </div> : "";
                    } else {
                      schead = titl ? <div className="sctitle col-sm-12"> <span onClick={() => toggleCollapseSubcomponents(component.title)} className={`inside-title title hand ${theme} ${isUnicodeTitle}`} style={{ paddingRight: padright }}>{titl[0]}{titl[1] && <ClickableIcon action={iconaction} icon={titl[1]} current={current} />}</span>   </div> : "";
                    }

                    scfoot = footerText ? <div className="scfooter col-sm-12 right"> <span className={`footer ${theme}`} style={{ paddingBottom: 2, borderBottomLeftRadius: 5, borderBottomRightRadius: 5, paddingLeft: 2, paddingRight: 2 }}>{footerText}</span></div> : "";
                  }

                  return (
                    <div key={index} style={{ marginTop: titl ? 5 : 0 }} className={`nopadding ${component.widths} `}>
                      {createComponent({ allc: formc, selectedFormTab: selectedFormTab, tabFastpath: component.fastpath ? component.fastpath : tabFastpath, wizard, grid, current, style, schead, scfoot, theme, showtag })}
                    </div>
                  );
                }
              } else {
                let { shouldRender, conditionalRender } = shouldDisplayComponent({ current, pageData, component, allData: current.props.parentState });

                let newcomp = cloneDeep(component);// JSON.parse(JSON.stringify(component)); // THIS will NOT copy functions from this object.

                if (LocalVars.confirmState) {
                  newcomp.isReadOnly = true;
                }

                // Check for current tab/fastpath 
                // fastpath is not assigned - dont show the tab.
                if (tabFastpath) {
                  let { formState } = current.props.parentState;
                  // can_update = true and disable_edit=true - show tab with all readonly fields.
                  if ((tabFastpath in forms) && ((pageData.unique_id && !forms[tabFastpath].can_update) || (!pageData.unique_id && !forms[tabFastpath].can_create_new))) {
                    newcomp.isReadOnly = true;
                  }
                  if (forms[tabFastpath] && forms[tabFastpath].disable_gui_update) { // Disable only for update.
                    newcomp.isReadOnly = true;
                  }
                  // can_update = true - show the tab with editable fields.
                }
                if (component.isReadOnly && component.isReadOnly != 'edit') {
                } else if (pageData.is_reverted && !pageData.is_auth && !pageData.can_auth) {
                  newcomp.isReadOnly = false;
                }

                if (shouldRender == 1) {

                  // console.log({ NAME: newcomp.name, conditionalRender })

                  if (newcomp.isRequired) {
                    let requiredFields = getCookie("requiredFields");
                    if (requiredFields) {
                      requiredFields = JSON.parse(requiredFields);
                    } else {
                      requiredFields = {};
                    }
                    requiredFields[newcomp.name] = 1;
                    setCookie("requiredFields", JSON.stringify(requiredFields));
                  }

                  return (
                    <AutoComponent
                      component={newcomp}
                      liftState={current.props.liftState}
                      liftGlobalState={current.props.liftGlobalState}
                      // parentStateGlobal={this.props.parentState}
                      parentState={current.props.parentState}
                      parentProps={current.props.parentProps}
                      key={index}
                      index={index}
                      conditionalRender={conditionalRender}
                    />
                  );

                } else {
                  let requiredFields = getCookie("requiredFields");
                  if (requiredFields) {
                    requiredFields = JSON.parse(requiredFields);
                    delete requiredFields[newcomp.name];
                  } else {
                    requiredFields = {};
                  }
                  setCookie("requiredFields", JSON.stringify(requiredFields));
                }
              }
            }
          })}
        </div>

        <div>{scfoot}</div>
      </div>
    );
  }

};


class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmit: false, isEdit: false
    };
  }

  toggleFormTab = tab => {
    let { LocalVars } = this.props.parentState;
    LocalVars["selectedFormTab"] = tab.uid;
    this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  };


  render() {
    let {
      fileFolder,
      formState,
      otherPage, showButtons, LocalVars,
      localpage, themecolor, currentPage
    } = this.props.parentState;
    let x;

    !themecolor ? themecolor = "default" : x = 0;

    let { selectedFormTab, showFilter } = LocalVars;

    const { profile } = this.props.parentProps.parentState;
    let forms2 = profile.forms;
    let forms = Object.keys(forms2);
    currentPage = currentPage.toLowerCase();
    // if (this.props.currentPage) { currentPage = this.props.currentPage; }

    if (localpage) {
      currentPage = localpage;
    }

    let boxpage = this.props.boxpage;
    if (boxpage) {
      currentPage = boxpage;
    }


    // instead of loading ALL pages in sidebararea, we only load the names, and on clicking page name, fetchData for that page.

    let {
      form,
      dashboard,
      pageType,
      formActions,
      wizard,
      preview,
      grid,
      formTabs,
      template,
      filter,
      bulk,
      theme
    } = this.props.parentState.formElements[currentPage];

    let tabbedForm = {};

    let allformtab = []
    if (formTabs) {
      form.map(formElem => {
        tabbedForm[formElem.tab]
          ? tabbedForm[formElem.tab].push(formElem)
          : (tabbedForm[formElem.tab] = [formElem]);

      });
    }
    let bulkCreator;
    if (bulk) {
      bulkCreator = [
        {
          inputType: "fileupload",
          widths: {
            parent: "col-sm-6",
            children: "col-sm-6"
          },
          readFile: { targetTable: 'bulk_uploads', type: 'csv', columns: bulk.columns },
          label: "Fileupload",
          name: "bulk_file_upload",
          placeholder: {
            type: "text",
            value: "Upload Bulk files"
          },
        },
        {
          inputType: "table",
          tableTitle: "",
          // convertedTo: "nominee_table",
          deletable: true,
          // editable: true,
          // addRows: true,
          height: 300,
          tableHeaders: bulk.columns.map(col => { return { label: col, field: col } }),
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "bulk_uploads"
        }
      ]
      tabbedForm['bulk'] = bulkCreator;
    }

    let allowedTabs = [];
    if (formTabs) {
      if (forms.indexOf('2') == -1) {
        formTabs.allTabs.map((tab, i) => {
          if (tab.fastpath) {
            if (forms.indexOf(tab.fastpath) == -1) {
            } else {
              allowedTabs.push(tab);
            }
          } else {
            allowedTabs.push(tab);
          }
        })
      } else {
        allowedTabs = formTabs.allTabs;
      }
    }

    let displayTabs = [];

    allowedTabs.map((tab, i) => {
      let shouldRender = 1;
      if (selectedFormTab == "") {
        selectedFormTab = tab.uid
      }

      if (tab.parents) {
        for (let i = 0; i < tab.parents.length; i++) {
          let elem = tab.parents[i];

          const parentVal = this.props.parentState.pageData[
            elem.name
          ];
          if (
            elem.match === "in" &&
            elem.value.indexOf(parentVal) != -1
          ) {
            shouldRender = 1;
          } else shouldRender = 0;
        }
      }
      if (shouldRender === 1) {
        displayTabs.push(tab);
      }
    });


    return (
      <div
        style={{ marginTop: 0 }}
        className={`SearchArea form-section ${boxpage ? "" : themecolor + "-form-section"} ${this.props.parentState.LocalVars.formSubmittedClass
          }`}
      >
        {formTabs && allowedTabs && (
          <div>
            <Nav
              tabs
              className={`${formTabs.options && formTabs.options.aligned
                ? formTabs.options.aligned
                : ""
                }`}
            >
              {displayTabs.map((tab, i) => {
                return (
                  <NavItem key={i} id={tab.uid}>
                    <NavLink
                      style={{
                        ...tab.style
                        // ...{
                        //   color: requiredTabs[tab.uid] ? "" : "red"
                        // }
                      }}
                      className={classnames({
                        active: selectedFormTab === tab.uid,
                        androidText: selectedFormTab === tab.uid
                        // animated: selectedFormTab === tab.uid,
                        // flipInX: selectedFormTab === tab.uid,
                      })}
                      onClick={() => {
                        this.toggleFormTab(tab);
                      }}
                    >
                      {tab.label}
                    </NavLink>
                  </NavItem>
                );
              })}
            </Nav>

            <TabContent activeTab={selectedFormTab}>
              {displayTabs.map((tab, i) => {

                return (
                  <TabPane style={{ paddingTop: 2 }} key={i} tabId={tab.uid}>
                    {/* Create steps */}
                    {createComponent({
                      allc: tabbedForm[tab.uid],
                      selectedFormTab,
                      tabFastpath: tab.fastpath,
                      wizard,
                      grid,
                      current: this,
                      style: {
                        border: "none",
                        marginTop: 0,
                        padding: 0
                      }, theme
                    })}
                    {preview && this.createPreview(selectedFormTab, preview)}
                    {grid && this.createGrid(grid)}
                  </TabPane>
                )
              }
              )}
            </TabContent>
          </div>
        )}

        {!formTabs && (
          <div className="col-sm-12"><div className="row">{createComponent({ allc: dashboard ? dashboard : form, selectedFormTab, wizard, grid, current: this, theme })} </div> </div>
        )}

        {bulk && !fileFolder.isOpen && selectedFormTab == 'bulk' &&
          <div className="col-sm-12"><div className="row">
            {/* {createComponent({ allc: bulkCreator, selectedFormTab, wizard, grid, current: this, theme })} */}
            <Button
              outline
              size="sm"
              id="excel-download-button"
              className="col-sm-2"
              onClick={() => simple_csv_download({ rows: [bulk.columns], filename: currentPage + "_sample" })}
            >
              <FaFileExcel /> Sample
            </Button>
          </div> </div>
        }


        {this.props.parentState.openmodals.length == 0 &&
          <span>
            {/* <SubmitCustom
              parentState={this.props.parentState}
              liftGlobalState={this.props.liftGlobalState}
              liftWrapperState={this.props.liftWrapperState}
              parentProps={this.props.parentProps}
            /> */}

            <EditCustom
              parentState={this.props.parentState}
              liftGlobalState={this.props.liftGlobalState}
              liftWrapperState={this.props.liftWrapperState}
              parentProps={this.props.parentProps}
            />

            <DeleteCustom
              parentState={this.props.parentState}
              liftGlobalState={this.props.liftGlobalState}
              liftWrapperState={this.props.liftWrapperState}
              parentProps={this.props.parentProps}
            />
          </span>
        }
      </div>

    );
  }
}

export default index;
